var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a, _b;
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import theme from '../consts/theme';
var baseStyles = css((_a = {
        appearance: 'none',
        backgroundColor: 'transparent',
        border: 'none',
        cursor: 'pointer',
        fontSize: '1rem',
        fontFamily: theme.fontFamily.sans,
        lineHeight: 1.5,
        padding: 0,
        width: '100%'
    },
    _a[theme.breakpoints.md] = {
        width: 'auto',
    },
    _a['&:disabled'] = {
        cursor: 'default',
        opacity: 0.5,
        pointerEvents: 'none',
    },
    _a));
var buttonStyles = css((_b = {
        borderColor: 'transparent',
        borderStyle: 'solid',
        borderWidth: 1,
        border: '1px solid transparent',
        borderRadius: 9999,
        display: 'inline-block',
        padding: '0.75rem 1.5rem',
        textAlign: 'center',
        transitionDuration: '150ms',
        transitionProperty: 'background-color, border-color, color',
        transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)'
    },
    _b[theme.breakpoints.lg] = {
        padding: '1rem 2rem',
    },
    _b));
var stylesByVariant = {
    primary: css({
        backgroundColor: theme.colors.helsinkiBlueDark,
        color: theme.colors.white,
        '&:hover': {
            backgroundColor: theme.colors.ensoBlue,
            color: theme.colors.helsinkiBlue,
        },
    }),
    reverse: css({
        borderColor: theme.colors.helsinkiBlueDark,
        color: theme.colors.helsinkiBlueDark,
        '&:hover': {
            backgroundColor: theme.colors.helsinkiBlueDark,
            color: theme.colors.white,
        },
    }),
    basic: css({
        color: 'inherit',
    }),
};
var Button = function (_a) {
    var children = _a.children, css = _a.css, _b = _a.type, type = _b === void 0 ? 'button' : _b, _c = _a.variant, variant = _c === void 0 ? 'primary' : _c, props = __rest(_a, ["children", "css", "type", "variant"]);
    var styles = [baseStyles];
    // Add button styles for pill-style buttons
    if (variant !== 'basic')
        styles.push(buttonStyles);
    styles.push(stylesByVariant[variant]);
    if (css)
        styles.push(css);
    return (_jsx("button", __assign({ css: styles, type: type, "data-variant": variant }, props, { children: children })));
};
export default Button;
//# sourceMappingURL=data:application/json;base64,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